import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {MatBadgeModule} from '@angular/material/badge';
import { HeaderComponent } from './header.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatBadgeModule,
    MatTooltipModule,
    RouterLink,
  ],
  declarations: [
    HeaderComponent
  ],
  providers: [],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {}
